/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useDrag } from 'react-dnd';
import { Flyout } from '@els/els-react--flyout';
import { Button, ButtonWithIcon } from '@els/els-react--button';
import { editHistoryQuery as editHistoryQueryAction } from '@Pages/QueryBuilder/QueryletActions';
import QuickSearchQuery from '@Pages/QuickSearch/Components/QuickSearchQuery/QuickSearchQuery';
import { recordCountOrTotalResultFromHistoryItem } from '@Containers/PatentFamilyClustering/selectors';
import { commaFormatNumber, replaceCitations } from '@Utils/String';

import './HistoryDragNode.scss';

function HistoryDragNode({ node, addToBuilder }) {
  const [{ isDragging }, dragRef] = useDrag(
    {
      type: 'DragNode',
      item: { node, type: 'DragNode' },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    },
    [node]
  );
  const dispatch = useDispatch();

  const editHistoryQuery = () => {
    dispatch(editHistoryQueryAction(node));
  };

  useEffect(() => {
    if (isDragging) document.body.style.cursor = 'move !important';
    else document.body.style.cursor = 'normal';
  }, [isDragging]);

  return (
    <div className="query-builder-search-section__drag-node">
      <div
        className="query-builder-search-section__drag-node-content"
        onClick={(e) => e.currentTarget === e.target && addToBuilder(node)}
        onKeyDown={(e) => e.currentTarget === e.target && addToBuilder(node)}>
        <Button type="link" className="u-els-ellipsis" onClick={(e) => addToBuilder(node) && e.stopPropagation()}>
          <div className="qb-hsitroy-node-header u-els-margin-bottom-1o4">
            {`${commaFormatNumber(recordCountOrTotalResultFromHistoryItem(node))} ${replaceCitations(node.context)}`}
          </div>
          <QuickSearchQuery querylet={node} />
        </Button>
        <div style={{ display: 'flex' }}>
          {(node.whereClauseImportToken || node?.quickSearchItem?.whereClauseImportToken || node.queryFactItem?.id) && (
            <Flyout trigger="hover" className="qb-drag-node-icon" flyout="Edit query" placement="bottom" theme="simple">
              <ButtonWithIcon
                id={`edit-history-query-${node.id}`}
                iconOnly
                type="link"
                linkIconSize="s"
                size="small"
                sprite="Edit"
                onClick={editHistoryQuery}>
                Edit history item
              </ButtonWithIcon>
            </Flyout>
          )}
          <div ref={dragRef} aria-live="polite">
            {isDragging && <span className="sr-only">{node.displayName} is dragging to querybuilder area</span>}
            <Flyout trigger="hover" flyout={<span aria-hidden="true">Drag query</span>} placement="bottom" theme="simple">
              <ButtonWithIcon
                id={`querybuilder-draghistory-${node.id}`}
                draggable
                className="cursor-move"
                onClick={(dragE) => dragE.stopPropagation()}
                linkIconSize="xxs"
                iconOnly
                type="borderless"
                aria-grabbed={isDragging}
                sprite="Drag"
                tabIndex="-1">
                drag
              </ButtonWithIcon>
            </Flyout>
          </div>
        </div>
      </div>
    </div>
  );
}

HistoryDragNode.propTypes = {
  node: PropTypes.object,
  addToBuilder: PropTypes.func,
};

export default HistoryDragNode;
